import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface Bill {
  id: string;
  amount: number;
  dueDate: string;
  status: 'Paid' | 'Unpaid' | 'Overdue';
}

interface BillingState {
  bills: Bill[];
  loading: boolean;
  error: string | null;
}

const initialState: BillingState = {
  bills: [],
  loading: false,
  error: null,
};

const billingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    setBills: (state, action: PayloadAction<Bill[]>) => {
      state.bills = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setBills, setLoading, setError } = billingSlice.actions;

// Memoized selectors
export const getUnpaidBills = createSelector(
  [(state: RootState) => state.billing.bills],
  (bills) => bills.filter((bill: Bill) => bill.status === 'Unpaid' || bill.status === 'Overdue')
);

export const getBillingLoading = (state: RootState): boolean => state.billing.loading;
export const getBillingError = (state: RootState): string | null => state.billing.error;

export default billingSlice.reducer; 